(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feds-polo-editorial"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('feds-product-story')){
  customElements.define('feds-product-story',class extends HTMLElement{
    connectedCallback(){
      this.controller=new AbortController();
      const signal=this.controller.signal;
      this.querySelectorAll('.fe-carousel').forEach(carousel=>{
        const track=carousel.querySelector('.fe-product-track');
        const previous=carousel.querySelector('[data-direction="-1"]');
        const next=carousel.querySelector('[data-direction="1"]');
        const update=()=>{previous.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2};
        carousel.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.direction)*track.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}),{signal}));
        track.addEventListener('scroll',update,{signal,passive:true});
        window.addEventListener('resize',update,{signal});
        update();
      });
      const thumbs=document.querySelector('.product-main .media-thumbs');
      if(thumbs){
        this.observer=new MutationObserver(()=>{
          if(!matchMedia('(min-width:1024px)').matches)return;
          const active=thumbs.querySelector('[aria-current="true"]');
          if(active){const box=active.getBoundingClientRect(),rail=thumbs.getBoundingClientRect();if(box.top<rail.top||box.bottom>rail.bottom)thumbs.scrollTo({top:thumbs.scrollTop+box.top-rail.top,behavior:'smooth'})}
        });
        this.observer.observe(thumbs,{subtree:true,attributes:true,attributeFilter:['aria-current']});
      }
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect()}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
